export const SEARCH_TERM_KEY = 'searchTerm'

export const SEARCH_HISTORY_KEY = 'previousSearches'

export const ASSETS_ENDPOINT = 'https://assets.ur.se'

export const MINORITY_LANGUAGES = [
  'finska',
  'samiska',
  'romani',
  'jiddisch',
  'meankieli',
]
